export default __webpack_public_path__ + "static/media/gordon-betty-moore-foundation.4783c167.png";